import { render, staticRenderFns } from "./PersianDate.vue?vue&type=template&id=7aa11f6e&"
import script from "./PersianDate.vue?vue&type=script&lang=js&"
export * from "./PersianDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports